import { render, staticRenderFns } from "./DownloadApp.vue?vue&type=template&id=0dd4bc60&"
import script from "./DownloadApp.vue?vue&type=script&lang=ts&"
export * from "./DownloadApp.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports